import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/Crl8GalleryView.jsx';

export default define`CRL8 Gallery View`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/Crl8GalleryView`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
